var map = {
	"./absenteeism of-sweeper": 1860,
	"./absenteeism of-sweeper.js": 1860,
	"./account-alert": 1861,
	"./account-alert.js": 1861,
	"./accountsbranch": 1862,
	"./accountsbranch.js": 1862,
	"./accumulation-of-litter": 1863,
	"./accumulation-of-litter.js": 1863,
	"./advertisement": 1864,
	"./advertisement.js": 1864,
	"./advertisement2": 1865,
	"./advertisement2.js": 1865,
	"./animals": 1866,
	"./animals.js": 1866,
	"./birth-death": 1867,
	"./birth-death.js": 1867,
	"./birthcertificate": 1868,
	"./birthcertificate.js": 1868,
	"./blood-bank": 1869,
	"./blood-bank.js": 1869,
	"./bookingbranch": 1870,
	"./bookingbranch.js": 1870,
	"./buildingbranch": 1871,
	"./buildingbranch.js": 1871,
	"./calendar": 1872,
	"./calendar.js": 1872,
	"./check-circle": 1873,
	"./check-circle.js": 1873,
	"./circle": 1874,
	"./circle.js": 1874,
	"./closed-complaints": 1875,
	"./closed-complaints.js": 1875,
	"./comment-plus": 1876,
	"./comment-plus.js": 1876,
	"./computercell": 1877,
	"./computercell.js": 1877,
	"./dashboard-complaint": 1878,
	"./dashboard-complaint.js": 1878,
	"./dashboard-propertytax": 1879,
	"./dashboard-propertytax.js": 1879,
	"./deathcertificate": 1880,
	"./deathcertificate.js": 1880,
	"./disposalofmalwa": 1881,
	"./disposalofmalwa.js": 1881,
	"./drains": 1882,
	"./drains.js": 1882,
	"./edcr": 1883,
	"./edcr.js": 1883,
	"./encroachment": 1884,
	"./encroachment.js": 1884,
	"./establishment": 1885,
	"./establishment.js": 1885,
	"./estatebranch": 1886,
	"./estatebranch.js": 1886,
	"./facebook": 1887,
	"./facebook.js": 1887,
	"./file-check": 1888,
	"./file-check.js": 1888,
	"./file-download": 1889,
	"./file-download.js": 1889,
	"./file-plus": 1890,
	"./file-plus.js": 1890,
	"./file-send": 1891,
	"./file-send.js": 1891,
	"./filter": 1892,
	"./filter.js": 1892,
	"./fire": 1893,
	"./fire-station": 1894,
	"./fire-station.js": 1894,
	"./fire.js": 1893,
	"./firewing": 1895,
	"./firewing.js": 1895,
	"./footpaths": 1896,
	"./footpaths.js": 1896,
	"./garbage": 1897,
	"./garbage-bin-absent": 1898,
	"./garbage-bin-absent.js": 1898,
	"./garbage-burn": 1899,
	"./garbage-burn.js": 1899,
	"./garbage-dump": 1900,
	"./garbage-dump.js": 1900,
	"./garbage.js": 1897,
	"./hamburger": 1901,
	"./hamburger.js": 1901,
	"./hcIcon": 1902,
	"./hcIcon.js": 1902,
	"./help-circle": 1903,
	"./help-circle.js": 1903,
	"./home-account": 1904,
	"./home-account.js": 1904,
	"./home-city-outline": 1905,
	"./home-city-outline.js": 1905,
	"./horticulture": 1906,
	"./horticulture.js": 1906,
	"./hospital": 1907,
	"./hospital.js": 1907,
	"./houseallotmentcommittee": 1908,
	"./houseallotmentcommittee.js": 1908,
	"./housetax": 1909,
	"./housetax.js": 1909,
	"./landviolations": 1910,
	"./landviolations.js": 1910,
	"./legalbranch": 1911,
	"./legalbranch.js": 1911,
	"./library-books": 1912,
	"./library-books.js": 1912,
	"./licencebranch": 1913,
	"./licencebranch.js": 1913,
	"./licenses": 1914,
	"./licenses.js": 1914,
	"./location-pin": 1915,
	"./location-pin.js": 1915,
	"./map-marker": 1916,
	"./map-marker.js": 1916,
	"./meathygiene": 1917,
	"./meathygiene.js": 1917,
	"./mechanicalwing": 1918,
	"./mechanicalwing.js": 1918,
	"./metering": 1919,
	"./metering.js": 1919,
	"./moh": 1920,
	"./moh.js": 1920,
	"./mosquitos": 1921,
	"./mosquitos.js": 1921,
	"./my-complaint": 1922,
	"./my-complaint.js": 1922,
	"./notifications": 1923,
	"./notifications.js": 1923,
	"./open-complaints": 1924,
	"./open-complaints.js": 1924,
	"./opendefecation": 1925,
	"./opendefecation.js": 1925,
	"./others": 1926,
	"./others.js": 1926,
	"./overflowing-garbage": 1927,
	"./overflowing-garbage.js": 1927,
	"./paidparking": 1928,
	"./paidparking.js": 1928,
	"./parkingbranch": 1929,
	"./parkingbranch.js": 1929,
	"./parks": 1930,
	"./parks.js": 1930,
	"./pensionbranch": 1931,
	"./pensionbranch.js": 1931,
	"./police-station": 1932,
	"./police-station.js": 1932,
	"./property-tax": 1933,
	"./property-tax.js": 1933,
	"./pt-example": 1934,
	"./pt-example.js": 1934,
	"./publicIcon": 1935,
	"./publicIcon.js": 1935,
	"./publiccommunitytoilet": 1939,
	"./publiccommunitytoilet.js": 1939,
	"./publictoilets": 1940,
	"./publictoilets.js": 1940,
	"./reassign-request": 1941,
	"./reassign-request.js": 1941,
	"./rehabilitationcolonies": 1942,
	"./rehabilitationcolonies.js": 1942,
	"./removalofdeadanimals": 1943,
	"./removalofdeadanimals.js": 1943,
	"./road-man-hole": 1944,
	"./road-man-hole.js": 1944,
	"./roads": 1945,
	"./roads.js": 1945,
	"./roadsandfootpaths": 1946,
	"./roadsandfootpaths.js": 1946,
	"./rtibranch": 1947,
	"./rtibranch.js": 1947,
	"./rupee": 1948,
	"./rupee.js": 1948,
	"./sanitation": 1949,
	"./sanitation.js": 1949,
	"./sewerage": 1950,
	"./sewerage.js": 1950,
	"./spcIcon": 1951,
	"./spcIcon.js": 1951,
	"./stormwater": 1952,
	"./stormwater.js": 1952,
	"./straycattle": 1953,
	"./straycattle.js": 1953,
	"./straydogs": 1954,
	"./straydogs.js": 1954,
	"./streetlight": 1955,
	"./streetlight.js": 1955,
	"./streetlights": 1956,
	"./streetlights.js": 1956,
	"./sub-office,manimajra": 1957,
	"./sub-office,manimajra.js": 1957,
	"./sub-officemanimajra": 1958,
	"./sub-officemanimajra.js": 1958,
	"./swarnajayantishaharirozgaryojana(nulm)": 1959,
	"./swarnajayantishaharirozgaryojana(nulm).js": 1959,
	"./tertiarywater": 1960,
	"./tertiarywater.js": 1960,
	"./timeline-assigned-icon": 1961,
	"./timeline-assigned-icon.js": 1961,
	"./trade-license": 1962,
	"./trade-license.js": 1962,
	"./trees": 1963,
	"./trees.js": 1963,
	"./twitter": 1964,
	"./twitter.js": 1964,
	"./water": 1965,
	"./water-pump": 1966,
	"./water-pump.js": 1966,
	"./water-tap": 1967,
	"./water-tap.js": 1967,
	"./water.js": 1965,
	"./waterandsewage": 1968,
	"./waterandsewage.js": 1968,
	"./watersupply": 1969,
	"./watersupply.js": 1969,
	"./whatsapp": 1970,
	"./whatsapp.js": 1970,
	"./zoom-in": 1971,
	"./zoom-in.js": 1971,
	"./zoom-out": 1972,
	"./zoom-out.js": 1972
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2264;


//////////////////
// WEBPACK FOOTER
// ./node_modules/egov-ui-kit/custom-icons ^\.\/.*$
// module id = 2264
// module chunks = 1143